import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import './ErrorMessage.less';
import { hasValue } from '../lib/utils';

const ErrorMessage = (props: ErrorMessageProps) => {
	const { message, absolute, center } = props;
	if (!hasValue(message)) {
		return null;
	}
	// TODO: Make this used styled components and remove all class names.
	return <div className={classNames({ error: true, absolute, center })}>{props.message}</div>;
};

interface ErrorMessageProps {
	message: string | React.Component | React.ReactNode;
	absolute?: boolean;
	center?: boolean;
}

ErrorMessage.defaultProps = {
	absolute: true,
	center: true
};

export default ErrorMessage;

export const ErrorDecorator = ({ children }: ErrorDecoratorProps) => {
	return <Self>{children}</Self>;
};

interface ErrorDecoratorProps {
	children: string | JSX.Element | JSX.Element[];
}

const Self = styled.div`
	color: #ff5151;
	font-size: 12px;
`;
